import { useTranslation } from "react-i18next";
import { FoodsIcon } from "@foodpilot/foods";
import { ListExportParamsInput, toListExportParams, useListExport } from "src/api/_common/export/useListExport";
import type { TableAction } from "./GridTableActions";

type UseListExportActionOptions = ListExportParamsInput & {
    path: string;
    fileNameStem: string;
    successMessage?: string;
    isDisabled?: boolean;
};

export const useListExportAction = (options: UseListExportActionOptions): TableAction => {
    const { path, fileNameStem, successMessage, isDisabled = false, ...paramsInput } = options;
    const { t } = useTranslation();
    const { exportList, isExporting } = useListExport({
        path,
        params: toListExportParams(paramsInput),
        fileNameStem,
        successMessage,
    });

    return {
        icon: <FoodsIcon icon="exportDownload" size={2} />,
        label: isExporting ? t("grid.table_actions.exporting", "Exporting…") : t("grid.table_actions.export", "Export"),
        isDisabled: isDisabled || isExporting,
        isBusy: isExporting,
        subActions: [
            {
                icon: <FoodsIcon icon="tableView" size={2} />,
                label: t("grid.table_actions.export_xlsx", "Export to Excel (.xlsx)"),
                onClick: () => exportList("xlsx"),
            },
            {
                icon: <FoodsIcon icon="documentation" size={2} />,
                label: t("grid.table_actions.export_csv", "Export to CSV (.csv)"),
                onClick: () => exportList("csv"),
            },
        ],
    };
};
